import LevelBase from './levelBase'
import { PIXEL_NAME, DIRS } from '../../utils/constants'
import { Player, Wall, Ground, Empty } from '../objects'


class LevelFinale extends LevelBase {
  constructor() {
    super()
    this.name = 'The escape'

    this.winningLoopRef = this.winningLoop.bind(this)
  }

  get id() {
    return this.constructor.key
  }

  async connectToScene(scene) {
    await super.connectToScene(scene)
    this.voidLevel = scene.children.getByName('layer_1').tilemap.height - 1
    this.fx = this.scene.sound.add('earthquake')
    // scene.events.once('levelstart', () => {
    //   scene.events.emit('dialogue:show', {
    //     participants: ['closeUp_Mary', 'closeUp_Tiamat'],
    //     conversation: [
    //       {
    //         who: 'closeUp_Tiamat',
    //         text: [
    //           "STOP!!",
    //           "I will destroy everything",
    //           "if i have to.",
    //           "you belong to me!!",
    //         ]
    //       }
    //     ]
    //   })
    // })
    scene.events.on('update', this.winningLoopRef)
    this.startVoid(scene)
    
  }
  startVoid(phaserScene) {
    const camera = phaserScene.cameras.main
    setTimeout(() => {
      camera.shake(2000, 0.005)
      this.fx.play()
    }, 1500)
    // destroy ground up to 1 tiles before player
  }
  playerLoop() {
    super.playerLoop()
    this.voidLoop()
  }
  resetAutoVoidTimer() {
    clearTimeout(this.autoDestroyTID)
    this.autoDestroyTID = setTimeout(this.destroyMap.bind(this), 5000)
  }
  destroyMap() {
    this.resetAutoVoidTimer()
    const layer = this.scene.children.getByName('layer_1')
    if(!layer) {
      return false
    }
    const { tilemap: map } = layer
    const camera = this.scene.cameras.main
    const y = this.voidLevel
    layer.fill(100, 0, y, map.width, 1)
    this.objects[y].forEach((el, x) => {
      if (el.isClass(Wall) || el.isClass(Ground)) {
        this.objects[y][x] = new Empty(PIXEL_NAME.EMPTY, this)
      }
    })
    
    this.moveables = this.moveables.filter(el => {
      if (el.position.y > this.voidLevel) {
        el.alien?.destroy()
        return false
      }
      return true
    })

    camera.shake(1000, 0.001)
    this.fx.play()
    this.voidLevel--

    // eval death.
    if (this.player.position.y > this.voidLevel) {
      this.player.die()
      this.onCharacterDie(this.player)
    }
  }
  voidLoop() {
    // detect player move direction
    if (this.player.isMoving && this.player.nextMoveDir === DIRS.UP) {
      this.resetAutoVoidTimer()
      // if moves up
      if(this.voidLevel - this.player.position.y > 8) {
        // only detroy ground when more than 3 tiles of space
        this.destroyMap()
      }
    } else if(this.player.isMoving && this.player.nextMoveDir !== '') {
      // if moves sides or down
      // destroy ground
      this.destroyMap()      
    }

  }
  destroy() {
    this.scene.events.off('update', this.winningLoopRef)
    this.fx.stop()
    clearTimeout(this.autoDestroyTID)
    
  }

  winningLoop() {
    if(this.player.position.y < 5) {
      clearTimeout(this.autoDestroyTID)
      this.scene.events.off('update', this.winningLoopRef)
      this.onComplete()
    }
  }

  onAddElement(el) {
    if(el.isClass(Player)) {
      el.power = 1
      el.hasPickaxe = true
    }
  }
}

LevelFinale.key = 'level_finale'
export default LevelFinale
